module.exports = __webpack_public_path__ + "img/processo_denuncia.685490d8.png";